const get = (form: PolicyFormSubmissionData, ref: string): PolicyFormSubmissionDataValue =>
  form[ref];
const getStr = (form: PolicyFormSubmissionData, ref: string): string =>
  String(get(form, ref) ?? '').trim();
const getNum = (form: PolicyFormSubmissionData, ref: string): number => {
  const v = get(form, ref);
  if (typeof v === 'number') return v;
  const s = getStr(form, ref).replace(/[, $]/g, '');
  const n = Number(s);
  return Number.isFinite(n) ? n : NaN;
};
const getTable = (form: PolicyFormSubmissionData, ref: string): Array<Record<string, any>> =>
  Array.isArray(form[ref]) ? (form[ref] as Array<Record<string, any>>) : [];
const isYes = (v: PolicyFormSubmissionDataValue) => String(v).toLowerCase() === 'yes';
const isNo = (v: PolicyFormSubmissionDataValue) => String(v).toLowerCase() === 'no';
const isWill = (v: PolicyFormSubmissionDataValue) => String(v).toLowerCase() === 'will';
const isDoes = (v: PolicyFormSubmissionDataValue) => String(v).toLowerCase() === 'does';
const isDoesNot = (v: PolicyFormSubmissionDataValue) => String(v).toLowerCase() === 'does-not';
const isEmail = (s: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s);
const isPhone = (s: string) => /^[+()\-.\s0-9]{7,}$/.test(s);
const isDateMDY = (s: string) =>
  /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.test(s) && !Number.isNaN(Date.parse(s));
const lt = (a: Date, b: Date) => a.getTime() < b.getTime();

const toDate = (v: PolicyFormSubmissionDataValue): Date | null => {
  if (!v) return null;
  if (v instanceof Date) return v;
  const s = String(v);

  const d = new Date(s);
  if (!Number.isNaN(d.getTime())) return d;
  if (isDateMDY(s)) return new Date(s);
  return null;
};

// Percent parser: accepts "33", "33%", "33.5"
const toPct = (s: string): number => {
  const cleaned = s.replace(/\s|%/g, '');
  const n = Number(cleaned);
  return Number.isFinite(n) ? n : NaN;
};

export {
  get,
  getStr,
  getNum,
  getTable,
  isYes,
  isNo,
  isWill,
  isDoes,
  isDoesNot,
  isEmail,
  isPhone,
  isDateMDY,
  lt,
  toDate,
  toPct,
};
